module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ECxcMr/tc-custom/9781423614395.jpg?1736859741384",
      "alt": "This image is the cover for the book 200 Appetizers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("200 Appetizers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Start any party or dinner off right with a selection from this wide array of delectable appetizer recipes by the authors of "), _c('i', [_vm._v("Burritos!")])])]), _c('p', [_vm._v("An appetizer by any other name be it hor d’oeuvres, canape, tidbit, or morsel, is still the yummiest way to tease your taste buds prior to the main course event. However, with "), _c('i', [_vm._v("200 Appetizers")]), _vm._v(", and an offering of recipes such as Shrimp Topped Avocado Mousse, Apricot Pistachio Phyllo Purses, Savory Rugalach, Mad Greek Dip, or Mongolian Meatballs, you may want to skip dinner and let the finger food fill you up.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Donna Kelly, Sandra Hoopes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Donna Kelly is the author of several cookbooks, including French Toast, 101 Things To Do With a Tortilla, 101 Things To Do With Chicken, 101 Things To Do With Tofu, 101 Things To Do with Canned Soup, and 101 Things To Do With a Toaster Oven. She lives in Provo, Utah. Sandra Hoopes recently graduated from culinary school with an added pastry certificate. She enjoys taking cooking classes from great chefs in Phoenix, Santa Fe and at the Culinary Institute of America in Hyde Park, New York. Sandra is currently the Foods Editor for the Puma Press in Phoenix.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0